/* Keep Avis paid option lines paired with their parent when updating/removing.
   These relationship properties are provided by the existing Avis integration. */
(() => {
  const form = document.querySelector('#cart');
  if (!form) return;
  const lines = [...form.querySelectorAll('[data-line-key]')];
  const error = form.querySelector('[data-cart-error]');
  const update = form.querySelector('[name="update"]');
  const status = form.querySelector('[data-cart-update-status]');
  let updateTimer;
  if (update) update.hidden = true;
  form.querySelectorAll('[data-cart-step]').forEach(button => {
    button.hidden = false;
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      if (button.dataset.cartStep === '1') input.stepUp(); else input.stepDown();
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
  form.addEventListener('change', event => {
    const input = event.target;
    if (input.name !== 'updates[]' || input.readOnly || !input.checkValidity()) return;
    const minus = input.parentElement.querySelector('[data-cart-step="-1"]');
    if (minus) minus.disabled = Number(input.value) <= 1;
    if (input.closest('[data-pack-editor]')) { clearTimeout(updateTimer); return; }
    syncOptions();
    status.textContent = 'Updating your cart… Pickup availability will be checked again.';
    update.hidden = false;
    clearTimeout(updateTimer);
    updateTimer = setTimeout(() => { form.removeAttribute('target'); form.querySelector('input[name="checkout"]')?.remove(); form.requestSubmit(update); }, 450);
  });
  document.querySelector('[data-go-pickup]')?.addEventListener('click', event => {
    event.preventDefault(); const summary = document.querySelector('#Cart-pickup'); summary.focus(); summary.scrollIntoView({ block: 'start' });
  });
  function syncOptions() {
    lines.filter(line => line.dataset.optionParent).forEach(child => {
      const parent = lines.find(line => line.dataset.optionOrder === child.dataset.optionParent);
      if (!parent) return;
      const quantity = Number(parent.querySelector('[name="updates[]"]').value);
      const multiplier = Number(child.dataset.optionMultiplier) || 1;
      child.querySelector('[name="updates[]"]').value = Math.max(0, quantity * multiplier);
    });
  }
  form.addEventListener('input', event => { if (event.target.name === 'updates[]') syncOptions(); });
  form.addEventListener('submit', syncOptions, true);
  form.addEventListener('click', async event => {
    if (event.target.closest('[name="update"], [name="checkout"]')) syncOptions();
    const remove = event.target.closest('[data-remove-line]');
    if (!remove) return;
    const parent = remove.closest('[data-line-key]');
    const children = lines.filter(line => parent.dataset.optionOrder && line.dataset.optionParent === parent.dataset.optionOrder);
    if (!children.length) return; // Native removal handles ordinary products.
    event.preventDefault();
    if (remove.dataset.busy) return;
    remove.dataset.busy = 'true';
    remove.setAttribute('aria-disabled', 'true');
    error.hidden = true;
    try {
      // Pickeasy can add properties after render, changing line keys. Resolve the
      // stable parent group against the current cart instead of using stale keys.
      const root = window.Shopify?.routes?.root || '/';
      const group = parent.dataset.optionOrder;
      const belongsToCake = item => {
        const props = item.properties || {};
        return (props._apo_order || props._hb_cake_group) === group || (props._apo_parent_order || props._hb_cake_parent) === group;
      };
      let removed = false;
      for (let attempt = 0; attempt < 2; attempt++) {
        const current = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!current.ok) throw new Error('Unable to read cart');
        const cart = await current.json();
        const paired = cart.items.filter(belongsToCake);
        if (!paired.length) { removed = true; break; }
        const updates = Object.fromEntries(paired.map(item => [item.key, 0]));
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates })
        });
        if (!response.ok) throw new Error('Unable to update cart');
        const result = await response.json();
        if (!result.items.some(belongsToCake)) { removed = true; break; }
      }
      if (!removed) throw new Error('The cart changed during removal');
      if (window !== window.parent && typeof window.parent.hbDrawerCartAdded === 'function') window.parent.hbDrawerCartAdded(window);
      else location.reload();
    } catch {
      error.textContent = 'We couldn’t remove that cake. Refresh the page to check your cart, then try again.';
      error.hidden = false;
      error.focus();
      delete remove.dataset.busy;
      remove.removeAttribute('aria-disabled');
    }
  }, true);
})();
